$('.chosen-select').chosen({
    disable_search_threshold: 12,
    width: '100%'
});

let frameMsg = null;

jQuery(document).ready(function ($) {
    // The following code is a merge of frameMsg.js and resizeHelper.js from the ogr-framework.
    // The code from frameMsg.js is saved as the frameMsk object creation function
    // and the resizeHelper.js file is saved as the frameMsg.resizeHelper object creation function.
    frameMsg = (function () {
        var eventMethod = (window.addEventListener) ? 'addEventListener' : 'attachEvent',
            messageEvent = (window.ogrMsgEvent) ? 'ogrMsgEvent' : (eventMethod === 'attachEvent') ? 'onmessage' : 'message',
            eventer = window[eventMethod],
            isReady = false,
            id,
            source,
            origin,
            currentHeight,
            isUpdating = false,
            body = $('body'),
            resizeHelper = (function () {
                var resizes = [],
                    resizeHelper,
                    mediaqueryHelper,
                    media = 'desktop',
                    device = 'desktop';

                // read media-query state
                mediaqueryHelper = function () {
                    var newMedia,
                        newDevice;

                    // try reading css values
                    try {
                        newMedia = window.getComputedStyle(document.body, ':after').getPropertyValue('content');
                        newDevice = window.getComputedStyle(document.body, ':before').getPropertyValue('content');
                        // replace characters that browsers are rendering into the strings
                        newMedia = newMedia.replace(/["']/gi, '');
                        newDevice = newDevice.replace(/["']/gi, '');
                    } catch (e) {
                        newMedia = 'desktop';
                        newDevice = 'desktop';
                    }

                    // fallback or set new values
                    media = (newMedia.length) ? newMedia : 'desktop';
                    device = (newDevice.length) ? newDevice : 'desktop';
                };
                mediaqueryHelper();
                resizes.push(mediaqueryHelper);

                resizeHelper = function () {
                    var i = 0,
                        count = resizes.length;

                    for (; i < count; i++) {
                        resizes[i].call();
                    }
                };

                $(window).on('resize', resizeHelper);

                return {
                    add: function (f) {
                        if (typeof f === 'function') {
                            resizes.push(f);
                            return resizes.length - 1;
                        }
                        return -1;
                    },

                    remove: function (f) {
                        var i = 0,
                            l = resizes.length;

                        for (; i < l; i++) {
                            if (resizes[i] === f) {
                                resizes[i] = $.noop;
                                break;
                            }
                        }
                    },

                    getDevice: function () {
                        return device;
                    },

                    getMedia: function () {
                        return media;
                    },

                    match: function (values) {
                        var type = $.type(values),
                            count = values.length,
                            found = false,
                            i;

                        if (type === 'string') {
                            found = (media === values);
                        }

                        if (type === 'array') {
                            for (i = 0; i < count; i++) {
                                if (media === values[i]) {
                                    found = true;
                                    break;
                                }
                            }
                        }

                        return found;
                    }

                };
            })();

        // get the value for box-shadow
        function getBoxShadow($el) {

            var boxShadow = $el.css('box-shadow'),
                result = 0,
                i = 0;

            // none or inset box-shadow are not relevant
            if (boxShadow === 'none' || boxShadow.search(/inset/ig) > -1) {
                return result;
            }

            // remove color and units
            boxShadow = boxShadow
                .replace(/rgb(a){0,1}\([\d\s,.]*\)/ig, '')
                .replace(/px/ig, '');

            // remove whitespace around all and split into array
            boxShadow = $.trim(boxShadow).split(' ');

            // parse all values to numbers
            for (; i < boxShadow.length; i++) {
                boxShadow[i] = parseInt(boxShadow[i], 10);
            }

            // test the result
            if (boxShadow.length !== 4 || isNaN(boxShadow[0]) || isNaN(boxShadow[1]) || isNaN(boxShadow[2]) || isNaN(boxShadow[3])) {
                return result;
            }

            // calculate the result
            result = boxShadow[2] + boxShadow[3];

            return result;
        }

        // calculate the height of the document
        function calcHeight() {
            var maxhabs,
                // add one pixel because FF cuts of decimal places so the number is not rounded up
                maxhrel = Math.ceil(document.body.offsetHeight) + 1,
                atotoffset = 0;

            // get all elements
            $.each(body.find('*:not(script)'), function () {
                var $el = $(this),
                    elOffset,
                    offsetTop,
                    offsetHeight,
                    boxShadow;

                if ($el.is(':visible') && $el.css('position') === 'absolute') {
                    offsetTop = $el.offset().top;

                    if (typeof offsetTop !== 'undefined') {
                        boxShadow = getBoxShadow($el);
                        offsetHeight = $el.context.offsetHeight;
                        elOffset = offsetTop + offsetHeight + boxShadow;

                        if (atotoffset < elOffset) {
                            atotoffset = elOffset;
                        }
                    }
                }
            });

            // absolute element offset position from the top
            maxhabs = Math.ceil(atotoffset);

            return (maxhrel > maxhabs) ? maxhrel : maxhabs;
        }

        // listen to custom postMessage-events
        eventer(messageEvent, function (event) {

            // data string, which is send by the parent-website, e.g. "height-2"
            var data = (window.iframeEvent) ? window.iframeEvent.data : event.data;

            // if no data return
            if (!data || typeof data !== 'string' || data.length === 0) {
                return;
            }

            // convert to an array
            data = data.split('-');

            // test if the array has two entries
            if (data.length !== 2) {
                return;
            }

            // the first entry has to be the height
            if (data[0] !== 'height') {
                return;
            }

            // the second entry has to be a number
            // this is the reference id for communication
            id = parseInt(data[1], 10);
            if (isNaN(id)) {
                id = undefined;
                return;
            }

            // save the source and orgin for later use
            source = (window.iframeEvent) ? window.iframeEvent.source : event.source;
            origin = (window.iframeEvent) ? window.iframeEvent.origin : event.origin;

            // all correct
            isReady = true;

            // send initial height of the body, without scrolling
            sendPostMessage(calcHeight(), false);
        }, false);

        // format: id-height-scrollposition (e.g. 2-300-0)
        function sendPostMessage(height, scrollposition) {
            if (!isReady) {
                return;
            }

            // save current height
            if (typeof height === 'number') {
                currentHeight = height;
            }

            // concat string
            var sendString = id + '-' + currentHeight;

            // add scroll if it is a number
            if (typeof scrollposition === 'number') {
                sendString += '-' + scrollposition;
            }

            // send
            source.postMessage(sendString, origin);
        }

        if (window.iframeEvent && window.ogrMsgEvent) {
            window.dispatchEvent(window.ogrMsgEvent);
        }

        function update() {
            if (!isUpdating) {
                isUpdating = true;

                var newHeight = calcHeight();

                if (newHeight !== currentHeight) {
                    sendPostMessage(newHeight, null);
                }

                isUpdating = false;
            }
        }

        // listen for resize, module creation and update calls
        resizeHelper.add(update);

        return {

            // calculates the height of the document inclusive absolute positioned elements
            calcDocumentHeight: function () {
                return calcHeight();
            },

            // set new height and scrollposition
            send: function (height, scrollposition) {
                sendPostMessage(height, scrollposition);
            },

            // updates the iframe height
            height: function (height) {
                sendPostMessage(height, null);
            },

            // scroll to a specific position
            scrollTo: function (scrollposition) {
                sendPostMessage(null, scrollposition);
            }
        };
    })();
    frameMsg.height(frameMsg.calcDocumentHeight());

});

/* --------------------------- */
/*  Custom code */
/* --------------------------- */


var $estateDetailActions = $('.actions-group'),
    $favoriteButton = $estateDetailActions.find('#add-to-favorite'),
    $printButton = $estateDetailActions.find('.print');

$favoriteButton.click(function (e) {
    e.preventDefault();
    var $this = $(this);

    if (!$this.hasClass('working')) {
        var $body = $(document.body);
        var estateId = $('.estate').data('estate-id');

        $this.addClass('working');
        if ($body.hasClass('favorited')) {
            $.post(FF.makeCompanyUrl('index.php/platformApi/removeFavoriteEstate/' + estateId))
                .always(function () {
                    $this.removeClass('working');
                })
                .done(function () {
                    $body.removeClass('favorited');
                });
        } else {
            $.post(FF.makeCompanyUrl('index.php/platformApi/addFavoriteEstate/' + estateId))
                .always(function () {
                    $this.removeClass('working');
                })
                .done(function () {
                    $body.addClass('favorited');
                });
        }
    }
});

$printButton.click(function (e) {
    e.preventDefault();
    window.print();
});



function setCookie_Helper(name, value, expiryDays) {
    var d = new Date();
    d.setTime(d.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
    document.cookie = name + "=" + value + "; expires=" + d.toUTCString() + "; path=/; SameSite=None; Secure";
}

$('#gallery-on-switch').click(function (e) {
    e.preventDefault();
    setCookie_Helper('estateView', 'gallery', 30);
    $('.estates-list').addClass('estates-list--gallery').removeClass('estates-list--list');
});

$('#list-on-switch').click(function (e) {
    if ($('body.favorited').length <= 0) {
        e.preventDefault();
    }
    setCookie_Helper('estateView', 'list', 30);
    $('.estates-list').addClass('estates-list--list').removeClass('estates-list--gallery');
});

function syncSortWithSearch(data) {
    var search = $('#search-order-field');
    if (search.length !== 0) {
        search.val(data.value);
    }
}


/* -- slider -- */

var $sliderOne = $('.slider-for');
var $sliderTwo = $('.slider-nav');
var $oguloFrame = $('.frame360');
var $oguloCloseButton = $oguloFrame.parent().find('.close-button-360');
var $immoFrame = $('.immo360');
var $immoViewerCloseButton = $immoFrame.parent().find('.close-button-360');

$sliderOne.on('init', function () {
    $('.gallery-main .slider').fadeIn();
});

/**
 * arrows and dots are only needed in small views, so don't be confused if you don't see them always ;)
 */
$sliderOne.slick({
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $sliderOne.parent().find('.slider-button-left'),
    nextArrow: $sliderOne.parent().find('.slider-button-right'),
    dots: false,
    fade: true,
    verticalSwiping: false,
    focusOnSelect: true,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                adaptiveHeight: true,
            }
        }
    ]
});
$sliderTwo.slick({
    focusOnSelect: true,
    slidesPerRow: 2,
    slidesToShow: 1,
    rows: 3,
    infinite: false,
    dots: false,
    arrows: true,
    prevArrow: $sliderTwo.parent().find('.slider-button-up'),
    nextArrow: $sliderTwo.parent().find('.slider-button-down'),
    verticalSwiping: true,
    vertical: true,
    responsive: [
        {
            breakpoint: 1023,
            settings: {
                rows: 2,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesPerRow: 1,
                rows: 1,
            }
        }
    ]
});

var killit = false;
var $navSlides = $sliderTwo.find('.slider-nav-image');

function navigateSlide(e) {
    if (!killit) {
        e.stopPropagation();
        var idx = $(this).data('thumb');
        $sliderOne.slick('goTo', idx - 1);
    }
}

$navSlides.on('click', navigateSlide);

$sliderTwo
    .on('beforeChange', function () {
        killit = true;
    }).on('afterChange', function () {
    killit = false;
});

$oguloFrame.closest('.ogulo-wrapper').on('click', function (e) {
    if (!e.isDefaultPrevented() && typeof $oguloFrame.attr('src') === 'undefined') {
        $oguloFrame.attr('src', $oguloFrame.data('src'));
        $oguloCloseButton.addClass('visible');
    }
});

$oguloFrame.parent().find('.close-button-360').on('click', function (e) {
    e.preventDefault();
    $oguloFrame.removeAttr('src');
    $oguloCloseButton.removeClass('visible');
});

$immoFrame.closest('.immo-wrapper').on('click', function (e) {
    if (!e.isDefaultPrevented() && typeof $immoFrame.attr('src') === 'undefined') {
        $immoFrame.attr('src', $immoFrame.data('src'));
        $immoViewerCloseButton.addClass('visible');
    }
});

$immoFrame.parent().find('.close-button-360').on('click', function (e) {
    e.preventDefault();
    $immoFrame.removeAttr('src');
    $immoViewerCloseButton.removeClass('visible');
});

$sliderOne.on('afterChange', function () {
    if ($oguloFrame
        && typeof $oguloFrame.attr('src') === 'undefined'
        && $oguloFrame.closest('.slick-slide').hasClass('slick-current')) {
        $oguloFrame.attr('src', $oguloFrame.data('src'));
        $oguloCloseButton.addClass('visible');
    }
    if ($immoFrame
        && typeof $immoFrame.attr('src') === 'undefined'
        && $immoFrame.closest('.slick-slide').hasClass('slick-current')) {
        $immoFrame.attr('src', $immoFrame.data('src'));
        $immoViewerCloseButton.addClass('visible');
    }
});


function currencyToGermanCurrencyFormat(number) {
    var currencyParts = number.toString().replace('.', ',').reverse().match(/\d{1,2},|\d{1,3}/g);
    return currencyParts === null
        ? number
        : currencyParts.map(function (e) {
            return e.reverse();
        }).reverse().join('.').replace(/\.,/g, ',');
}

function germanCurrencyFormatToCurrency(number) {
    return number.toString().replace(/\./g, '').replace(',', '.');
}

function syncAttributes(value, formField) {
    var selection = value.charAt(0).toUpperCase() + value.toLowerCase().slice(1),
        formFieldParser = function () {
            var formField = $(this),
                pattern = new RegExp('(.+)' + selection + '$'),
                data = $(this).data();
            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    var attrName = key.match(pattern);
                    if (attrName !== null && attrName.length > 1) {
                        formField.attr(attrName[1], data[key]);
                        return;
                    }
                }
            }
        };

    // Don't forget: 'tagName' is always UPPERCASE!
    switch (formField.prop('tagName')) {
        case 'SELECT':
            formField.children().each(formFieldParser);
            break;
        default:
            formField.each(formFieldParser);

    }
}

var priceInput = $('#price');

if (!!priceInput.length) {
    jsb.whenFired('selectmenu::change', {id: 'priceInterval'}, function (data) {
        syncAttributes(data.value, priceInput);
    });

    priceInput.val(currencyToGermanCurrencyFormat(priceInput.val()));

    priceInput.bind('change blur', function () {
        var newVal = currencyToGermanCurrencyFormat($(this).val());
        if (newVal !== $(this).val()) {
            $(this).val(newVal);
        }
    });

    priceInput.focus(function () {
        $(this).val(germanCurrencyFormatToCurrency($(this).val()));
    });
}

var geoFindMe = function () {
    var $button = $(this),
        $locationWrapper = $(this).closest('.text-field'),
        $locationField = $locationWrapper.find('input[name="zipTown"]'),
        $latField = $('#lat'),
        $lngField = $('#lng');

    $button.addClass('active');

    var success = function (position) {
        var lat = position.coords.latitude,
            lng = position.coords.longitude,
            successMsg = 'Lat: ' + lat.toFixed(3) + '…, ' + 'Long: ' + lng.toFixed(3) + '…';

        $latField.val(lat);
        $lngField.val(lng);
        $latField.trigger('change');

        $locationField.val(successMsg).attr('title', successMsg).trigger('input');
        $button.removeClass('active')
    };

    var error = function () {
        var errorMsg = 'Ihre Position konnte leider nicht bestimmt werden.';
        $locationField.val(errorMsg).attr('title', errorMsg).trigger('input');
        $button.removeClass('active')
    };

    navigator.geolocation.getCurrentPosition(success, error);
};

(navigator.geolocation) && $('.locate-btn').show().click(geoFindMe);

/**
 * Returns a jQuery Object of the Overlay
 * @param {String|jQuery|Element} element The overlay
 * @return {jQuery} The Overlay
 */
function getOverlay(element) {
    var $overlay = $(element);
    if (!$overlay.is('.overlay-box')) {
        $overlay = $overlay.find('.overlay-box');
    }
    return $overlay;
}

/**
 * Shows the modal
 * @param {String|jQuery|Element} element A selector, jQuery object or dom element which is a modal
 */
function openOverlay(element) {
    //Close all overlays (not necessary):
    //closeOverlay($('.ogr-panel').closest('.overlay-box'));
    //Show selected overlay
    var $overlay = getOverlay(element)
        //synchronous .show()
        .css('display', 'block')
        .scrollTop(0);
    $('body').addClass('disable-scrolling');
    trapFocus($overlay[0]);

    //Resize body if necessary
    resizeFrameForOverlay($overlay);
}

function trapFocus(element) {
    const focusableElements = element.querySelectorAll('a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])');
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    element.addEventListener('keydown', function(event) {
        if (event.key === 'Tab') {
            if (event.shiftKey) {
                if (document.activeElement === firstFocusable) {
                    event.preventDefault();
                    lastFocusable.focus();
                }
            } else {
                if (document.activeElement === lastFocusable) {
                    event.preventDefault();
                    firstFocusable.focus();
                }
            }
        }
    });

    firstFocusable.focus();
}

/**
 * Collapses and resets the modal
 * @param {String|jQuery|Element} element A selector, jQuery object or dom element which is a modal
 */
function closeOverlay(element) {
    var $overlay = getOverlay(element),
        $form = $overlay.find('form');
    $overlay
        .hide()
        .unbind('click');
    if ($form.length > 0) {
        $form[0].reset();
        $form.show();
    }
    $overlay.find('.ogr-notification--info').hide();
    $overlay.find('.ogr-confirm').removeClass('active');
    $overlay.find('.error').hide();
    $overlay.find('.ogr-errorbox').hide();
    $overlay.find('.close-row').hide();

    $form.find('.text-field').removeClass('text-field--error');
    $form.find('.text-field').removeClass('text-field--filled');
    $form.find('.text-field').find('.text-field__error').remove();
    $form.find('.checkbox').removeClass('checkbox--touched');

    $('body').removeClass('disable-scrolling');
    resizeFrameForOverlay($overlay);
}

function resizeFrameForOverlay($overlay) {
    //Check if the given object is really a dialog
    if (!$overlay instanceof jQuery || !$overlay.is('.overlay-box')) {
        return;
    }
    var $body = $(document.body);

    //Make sure the body has its "natural" height to determine whether or not a resize is necessary
    var $bodyStylesWithoutHeight = $body.attr('style');

    if ($bodyStylesWithoutHeight) {
        $bodyStylesWithoutHeight = $bodyStylesWithoutHeight.replace(/(?:max-)?height: *\d+.{0,3};?/g, '');
        if ($bodyStylesWithoutHeight !== '') {
            $body.attr('style', $bodyStylesWithoutHeight);
        } else {
            $body.removeAttr('style');
        }
    }

    if (!$overlay.is(':visible')) {
        //In case the body was resized it should be resettet
        $(window).resize();
        return;
    }

    //The overlay always contains 100% of the current window, the .ogr-panel its containing is the real overlay
    $overlay = $overlay.children('.box-area');

    //Calculate the maximum height from the dialog in relation to the body height
    var maxHeight = $overlay.css('max-height'),
        maxHeightAsFloat = 1;

    //If the max-height is given in percent we have to consider it
    if (maxHeight !== undefined && maxHeight.indexOf('%') > 0) {
        maxHeight = maxHeight.replace('%', '');
        if ($.isNumeric(maxHeight) && maxHeight !== '0') {
            maxHeight = Number(maxHeight);
            maxHeightAsFloat = maxHeight / 100;
        }
    }

    //Set the dialog box to its "natural" height, so we can see if it fits in the body
    $overlay.css({
        'max-height': 'none',
        'height': 'auto'
    });

    //Calculate the space needed for the dialog box to be shown in its full size
    var overlayMaxY = Math.ceil(($overlay.outerHeight() + $overlay.offset().top + 1) / maxHeightAsFloat);

    //Remove the dialog boxes "natural" height settings, so its shown as wanted
    $overlay.removeAttr('style');

    //If the needed height is bigger than the "natural" height of the body
    if (overlayMaxY > $body.innerHeight()) {
        //resize
        $body.innerHeight(overlayMaxY);
        $(window).resize();
    }

    frameMsg.scrollTo(0);
    if ('parentIFrame' in window) {
        parentIFrame.scrollToOffset(0, 0);
    }
}

window.onbeforeunload = function () {
    frameMsg.scrollTo(0);
    if ('parentIFrame' in window) {
        parentIFrame.scrollToOffset(0, 0);
    }
};

// $('#search-module').submit(function () {
//     var fields = $(this).find('select[name], input[name]');
//     fields.each(function () {
//         var field = $(this),
//             ogrField = field.siblings('[data-api-id="' + field.attr('id') + '"]'),
//             fieldIsVisible = (ogrField.length > 0 && ogrField.is(':visible')) || (ogrField.length === 0 && field.is(':visible'));
//         if (!fieldIsVisible && !field.is('[type="hidden"]') || field.val() === '') {
//             field.prop('disabled', true);
//         }
//     });
//
//     var priceFields = $("#price");
//     priceFields.each(function () {
//         $(this).val(germanCurrencyFormatToCurrency($(this).val()));
//     });
// });

$('.open-contact-button').click(function (e) {
    e.preventDefault();
    // Fix for missing scroll position within iPhone in iFrame, forces me to use the event position.
    $('#contact-box').css('padding-top', (e.pageY - 200) + 'px !important');
    openOverlay('#contact-box');
});

$('#close-contact-button').click(function (e) {
    e.preventDefault();
    closeOverlay('#contact-box');
});

// $('#close-contact-confirmation-button').click(function (e) {
//     e.preventDefault();
//     $('#contact-box').find('.close-contact-confirmation-button-div').removeClass('close-contact-confirmation-button-div-active');
//     closeOverlay('#contact-box');
// });

$('#contact-close-ogr-confirmation-button').click(function (e) {
    e.preventDefault();
    closeOverlay('#contact-box');
});

$('#forgetpassword-close-ogr-confirmation-button').click(function (e) {
    e.preventDefault();
    closeOverlay('#forgot-password-box');
});

$('#login-close-ogr-confirmation-button').click(function (e) {
    e.preventDefault();
    closeOverlay('#login-box');
});

$('#registration-close-ogr-confirmation-button').click(function (e) {
    e.preventDefault();
    closeOverlay('#registration-box');
});

$('.checkbox__input').change(function () {
    $(this).closest('.checkbox').addClass('checkbox--touched');
}).on('invalid', function () {
    $(this).closest('.checkbox').addClass('checkbox--touched');
});

$('#send-contact-form').submit(function (e) {
    e.preventDefault();

    var box = $('#contact-box'),
        form = box.find('form'),
        input = form.serializeArray(),
        successMessage = box.find('.ogr-confirm'),
        errorMessage = box.find('.error'),
        preLoader = new pre(box.find('.box-area'), {text: 'Ihre Kontaktanfrage wird übermittelt.'}),
        closeRow = box.find('.close');

    form.find('.text-field').removeClass('text-field--error');

    closeRow.hide();
    preLoader.show();

    $.post(FF.makeCompanyUrl('index.php/platformApi/vrSendEmail'), input, function (result, status) {
        preLoader.hide();
        if (status === 'success') {
            successMessage.addClass('active');
            successMessage.focus();
        } else {
            errorMessage.show();
            errorMessage.focus();
        }
        form.hide();
        closeRow.show();
        resizeFrameForOverlay(box);
    });
});

$('#open-login-button').click(function (e) {
    e.preventDefault();
    openOverlay('#login-box');
});

$('#close-login-button').click(function (e) {
    e.preventDefault();
    closeOverlay('#login-box');
});

$('#send-login-button').click(function (e) {
    var box = $('#login-box'),
        form = box.find('form'),
        input = form.serializeArray(),
        preLoader = new pre(box.find('.box-area'), {text: 'Ihre Anmeldedaten werden übermittelt.'}),
        successMessage = box.find('.ogr-confirm'),
        errorMessage = box.find('.error');

    e.preventDefault();

    if (!form[0].reportValidity()) {
        return;
    }

    preLoader.show();
    $.ajax({
        url: FF.makeCompanyUrl('index.php/platformApi/login'),
        type: 'POST',
        data: input,
        dataType: 'JSON',
        complete: function (xhr) {
            preLoader.hide();
            successMessage.removeClass('active');
            errorMessage.hide();

            if (xhr.status === 204) {
                successMessage.addClass('active');
                successMessage.focus();
                form.hide();

                location.reload();
            } else {
                errorMessage.show();
                errorMessage.focus();
            }
            resizeFrameForOverlay(box);
        }
    });
});

$('#logout-button').click(function () {
    (new pre($(document.body), {text: 'Logout wird durchgeführt.'})).show();
    $.post(FF.makeCompanyUrl('index.php/platformApi/logout'))
        .always(function () {
            location.reload();
        });
});

$('#user-delete-button').click(function () {

    customConfirm({
        title: 'Account löschen',
        text: '<p>Wollen Sie wirklich ihren Benutzeraccount <strong>unwiderruflich</strong> löschen?</p>'
    })
        .then(function (result) {
            if (result) {
                return customConfirm({
                    title: 'Account löschen',
                    text: '<p>Sind Sie wirklich sicher?</p>'
                });
            }
            return false;
        }).then(function doDeleteUser(result) {
        if (result) {
            (new pre($(document.body), {text: '<p>Löschung wird durchgeführt.</p>'})).show();
            $.ajax({
                url: FF.makeCompanyUrl('index.php/platformApi/userDelete'),
                method: 'POST',
                success: function () {
                    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
                    document.cookie = 'contact=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
                    location.reload();
                },
                error: function () {
                    customConfirm({
                        title: 'Account konnte nicht gelöscht werden',
                        text: '<p>Beim Löschen des Accounts ist ein Fehler aufgetreten. Erneut versuchen?</p>'
                    }).then(doDeleteUser);
                },
                complete: function () {
                    preLoader.hide();
                }
            });
        }
    });
});


function customConfirm(data) {
    if (typeof data === 'string') {
        data = {text: data};
    }
    return new Promise(function (resolve) {
        var $overlay = getOverlay('#confirm-box');

        var $yesButton = $overlay.find('.confirm-yes-button');
        var $noButton = $overlay.find('.confirm-no-button');

        $yesButton.on('click', function () {
            $yesButton.off('click');
            $noButton.off('click');
            closeOverlay($overlay);
            resolve(true);
        });

        $noButton.on('click', function () {
            $yesButton.off('click');
            $noButton.off('click');
            closeOverlay($overlay);
            resolve(false);
        });

        $overlay.find('.ogr-panel-title').text(data.title || 'Bestätigen');
        $overlay.find('.text-row').html(data.text || '');

        openOverlay($overlay);
    });
}


$('.action-menu-button').click(function () {
    $('.action-menu-overlay').toggleClass('opened');
});

$('.open-registration-button, #no-result-register').click(function (e) {
    e.preventDefault();
    openOverlay('#registration-box');
    closeOverlay('#login-box');
});

$('#close-registration-button').click(function (e) {
    e.preventDefault();
    closeOverlay('#registration-box');
    openOverlay('#login-box');
});

// fadeIn error box on focus
$('input').on('focus', function () {
    if ($(this).hasClass('error')) {
        var id = $(this).attr('id');
        var div = $(this).parent();
        var errorLagel = $('label[for="' + id + '"]');
        var errorInfo = $('#' + id + '-error');
        var text = errorInfo.text();
        div.addClass('error-active');
        errorLagel.append('<p>' + text + '</p>');
        errorInfo.children('p').remove();


    }
});

// fadeOut error box on focusout
$('.box-area input').on('blur', function () {
    if ($(this)) {
        var id = $(this).attr('id');
        var div = $(this).parent();
        var errorInfo = $('#' + id + '-error');
        var errorLagel = $('label[for="' + id + '"]');

        div.removeClass('error-active');
        errorInfo.children('p').remove();
        errorLagel.children('p').remove();
    }
});

$('#registration-form').submit(function (e) {
    e.preventDefault();

    var box = $('#registration-box'),
        form = box.find('form'),
        input = form.serializeArray(),
        preLoader = new pre(box.find('.box-area'), {text: 'Ihre Daten werden übermittelt.'}),
        successMessage = box.find('.ogr-confirm'),
        errorMessage = box.find('.ogr-generic-error-box'),
        alreadyRegisteredMessage = box.find('.ogr-already-registered-box'),
        requiredFieldsMessage = box.find('.ogr-required-error-box'),
        wrongPasswordMessage = box.find('.ogr-wrong-password-box'),
        shortPasswordMessage = box.find('.ogr-short-password-box'),
        closeRow = box.find('.close');

    preLoader.show();

    $.ajax({
        url: FF.makeCompanyUrl('index.php/platformApi/register'),
        type: 'POST',
        data: input,
        dataType: 'JSON',
        complete: function (xhr) {
            preLoader.hide();
            alreadyRegisteredMessage.hide();
            requiredFieldsMessage.hide();
            wrongPasswordMessage.hide();
            shortPasswordMessage.hide();
            errorMessage.hide();

            if (xhr.status === 204) {
                successMessage.addClass('active');
                successMessage.focus();
                // hide the form
                form.hide();
                closeRow.show();
            } else {
                //console.log(xhr.responseJSON);
                if (xhr.responseJSON.type === 'email_exists') {
                    alreadyRegisteredMessage.show();
                    alreadyRegisteredMessage.focus();
                } else if (xhr.responseJSON.type === 'missing_properties') {
                    requiredFieldsMessage.show();
                    requiredFieldsMessage.focus();
                } else if (xhr.responseJSON.type === 'password_too_short') {
                    shortPasswordMessage.show();
                    shortPasswordMessage.focus();
                } else if (xhr.responseJSON.type === 'passwords_not_matching') {
                    wrongPasswordMessage.show();
                    wrongPasswordMessage.focus();
                } else {
                    errorMessage.show();
                    errorMessage.focus();
                }
            }

            resizeFrameForOverlay(box);
        }
    });
});

$('.open-forgot-password-button').click(function (e) {
    e.preventDefault();
    openOverlay('#forgot-password-box');
    closeOverlay('#login-box');
});

$('#close-forgot-password-button').click(function (e) {
    e.preventDefault();
    closeOverlay('#forgot-password-box');
    openOverlay('#login-box');
});

$('#send-forgot-password-button').click(function (e) {
    e.preventDefault();

    var box = $('#forgot-password-box'),
        form = box.find('form'),
        input = form.serializeArray(),
        successMessage = box.find('.ogr-confirm'),
        //errorMessage = box.find('.error'),
        //closeRow = box.find('.close'),
        preloader = new pre(box.find('.box-area'), {text: 'Bitte warten!'});

    form.find('.text-field').removeClass('text-field--error');

    //if (!form[0].reportValidity()) {
    //    return;
    //}

    successMessage.removeClass('active');
    //errorMessage.hide();
    //closeRow.hide();
    form.show();

    //if (!form.valid()) {
    //    $('input').each(function () {
    //        if ($(this).hasClass('error')) {
    //            var div = $(this).parent().parent();
    //            //div.addClass('error-alert');
    //            div.addClass('text-field--error');
    //        }
    //    });
    //
    //    return;
    //}

    // show preloader, because ajax call can take some seconds.
    preloader.show();

    $.ajax({
        url: FF.makeCompanyUrl('index.php/platformApi/requestPasswordReset'),
        type: 'POST',
        data: input,
        dataType: 'JSON',
        complete: function (xhr) {
            if (xhr.status === 204) {
                successMessage.addClass('active');
                successMessage.focus();
                preloader.hide();
                // hide the form
                form.hide();
                closeRow.show();
            } else {
                //form.find('.text-field').addClass('text-field--error');
                form[0].reportValidity();
                //errorMessage.show();
                preloader.hide();
            }
            resizeFrameForOverlay(box);
        }
    });
});

$('#send-change-password-button').click(function () {
    var box = $('#change-password-box'),
        form = box.find('form'),
        input = form.serializeArray(),
        successMessage = box.find('.ogr-notification--info'),
        errorMessage = box.find('.ogr-errorbox'),
        pwd = box.find('#newpassword').val(),
        pwdRepeat = box.find('#newpasswordrepeat').val(),
        digit = box.find('strong'),
        preloader = new pre(box.find('.ogr-panel'), {text: 'Bitte warten!'});

    // stop if the two passwords couldn't be validated.
    if (!pwd || !pwdRepeat || pwd !== pwdRepeat) {
        return;
    }

    // show preloader, because ajax call can take some seconds.
    preloader.show();

    // a counter that is used, if the request was successful and the user should be forwarded to immoframe
    function startCountdown(startCounter, digit) {
        var timer = setInterval(function () {
            digit.text(--startCounter);
            startCounter === 0 && clearInterval(timer);
        }, 1000);
    }

    $.ajax({
        url: FF.makeCompanyUrl('index.php/platformApi/changePassword'),
        type: 'POST',
        data: input,
        dataType: 'JSON',
        success: function () {
            // if given time from FORM is NaN, seven seconds is default.
            var startCounterInSec = parseInt(digit.text()) || 7;

            successMessage.addClass('active');
            successMessage.focus();
            preloader.hide();
            startCountdown(startCounterInSec, digit);
            resizeFrameForOverlay(box);
            setTimeout(function () {
                // after given time, redirect user to immoframe.
                window.location.href = box.find('#redirect-link').prop('href');
            }, startCounterInSec * 1000);
        },
        error: function () {
            var msg = 'Leider trat ein technischer Fehler auf. Bitte versuchen Sie es später noch einmal.';
            errorMessage.find('.ogr-errorbox__description p').text(msg);
            errorMessage.show();
            errorMessage.focus();
            preloader.hide();
            resizeFrameForOverlay(box);
        }
    });
});

jQuery.each(['show', 'hide'], function (i, ev) {
    var el = $.fn[ev];
    $.fn[ev] = function () {
        this.trigger(ev);
        return el.apply(this, arguments);
    };
});

$('.favorite-estate-indicator').click(function () {
    var $this = $(this);
    var parent = $('.estates-list');

    if (!parent.hasClass('working')) {
        var $estate = $(this).closest('.estate');
        var estateId = $estate.data('estate-id');
        var $otherEstate = $(this).closest('ul').siblings('ul').find('.estate[data-estate-id="' + estateId + '"]');
        var $otherIndicator = $otherEstate.find('.favorite-estate-indicator');
        var $bothIndicators = $this.add($otherIndicator);

        parent.addClass('working');
        $this.addClass('working');
        if ($this.hasClass('favorited')) {
            $.post(FF.makeCompanyUrl('index.php/platformApi/removeFavoriteEstate/' + estateId)).always(function () {
                parent.removeClass('working');
                $this.removeClass('working');
            }).done(function () {
                $bothIndicators.removeClass('favorited');
            });
        } else {
            $.post(FF.makeCompanyUrl('index.php/platformApi/addFavoriteEstate/' + estateId)).always(function () {
                parent.removeClass('working');
                $this.removeClass('working');
            }).done(function () {
                $bothIndicators.addClass('favorited');
            });
        }
    }
});

class pre {
    element;

    constructor(container, options = {}) {
        const preloader = $('<div class="preloader"><div class="preloader__spinner"></div></div>');
        if (options && options.text) {
            preloader.attr('title', options.text);
        }
        $(container).append(preloader);

        this.element = preloader;
    }

    show() {
        this.element.addClass('preloader--visible');
    }

    hide() {
        this.element.removeClass('preloader--visible');
    }
}


$('#open-savesearch-button').click(function (e) {
    e.preventDefault();
    openOverlay('#savesearch-box');
});


$('#close-savesearch-button').click(function (e) {
    e.preventDefault();
    closeOverlay('#savesearch-box');
});


$('#savesearch-form').submit(function (e) {
    e.preventDefault();
    var box = $('#savesearch-box'),
        form = $(this),
        preLoader = new pre(box.find('.box-area'), {text: 'Ihre Daten werden übermittelt.'}),
        successMessage = box.find('.success'),
        errorMessage = box.find('.error'),
        formContent = box.find('.form-content'),
        params = form.data('params');

    preLoader.show();

    $.ajax({
        url: FF.makeCompanyUrl('index.php/platformApi/saveSearch'),
        type: 'POST',
        data: params,
        dataType: 'json'
    }).always(function () {
        preLoader.hide();
    }).done(function (data) {
        if (data.success) {
            successMessage.addClass('active');
            successMessage.focus();
            errorMessage.hide();
            formContent.hide();
            resizeFrameForOverlay(box);
            setTimeout(function () {
                closeOverlay(box);
            }, 3000);
        } else {
            successMessage.removeClass('active');
            if (data.reason) {
                errorMessage.text = data.reason;
            }
            errorMessage.show();
            errorMessage.focus();
            resizeFrameForOverlay(box);
        }
    }).fail(function () {
        successMessage.removeClass('active');
        errorMessage.show();
        errorMessage.focus();
        resizeFrameForOverlay(box);
    });
});

$('.text-field__input')
    .focus(function () {
        $(this).closest('.text-field').addClass('text-field--active');
    })
    .blur(function () {
        $(this).closest('.text-field').removeClass('text-field--active');
    })
    .on('input', function () {
        const $field = $(this).closest('.text-field');
        $field.removeClass('text-field--error');
        $field.find('.text-field__error').remove();
        if ($(this).val()) {
            $field.addClass('text-field--filled');
        } else {
            $field.removeClass('text-field--filled');
        }
    })
    .on('invalid', function (e) {
        e.preventDefault();
        const $input = $(this);
        const $field = $(this).closest('.text-field');
        $field.addClass('text-field--error');
        let error = $field.find('.text-field__error')[0];
        if (!error) {
            error = document.createElement('div');
            error.classList.add('text-field__error');
            const errorId = $input.attr('id') + '-error';
            error.id = errorId;
            error.setAttribute('role', 'alert');
            $field.append(error);
        }
        error.textContent = e.target.validationMessage;
        $input.attr('aria-describedby', error.id).attr('aria-invalid', 'true');
        $input.focus();

    })
    .each(function () {
        if ($(this).val()) {
            $(this).closest('.text-field').addClass('text-field--filled');
        }
    });

$('.select-box__select').each(function () {
    const select = this;
    const $select = $(select);
    const $box = $select.closest('.select-box');
    if ($select.is(':disabled')) {
        $box.addClass('select-box--disabled');
    }
    const $slot = $box.find('.select-box__slot');
    $select.hide();
    const activator = document.createElement('div');
    activator.classList.add('select-box__activator');
    const activatorText = document.createElement('div');
    activatorText.classList.add('select-box__activator-text');
    activator.appendChild(activatorText);
    if (this.selectedOptions.length === 1) {
        activatorText.innerText = this.selectedOptions[0].text;
    }
    $slot.append(activator);
    const menu = document.createElement('ul');
    menu.classList.add('select-box__menu');
    function addOption(option, inGroup) {
        const item = document.createElement('li');
        item.classList.add('select-box__menu-item');
        if (inGroup) {
            item.classList.add('select-box__menu-item--in-group');
        }
        if (option.selected === true) {
            item.classList.add('select-box__menu-item--selected');
        }
        item.innerText = option.text;
        item.addEventListener('click', function () {
            $select.val(option.value).trigger('change');
        });
        menu.appendChild(item);
    }
    for (const option of this.children) {
        if (option.tagName === 'OPTGROUP') {
            const groupLabelItem = document.createElement('li');
            groupLabelItem.classList.add('select-box__menu-group-label');
            groupLabelItem.innerText = option.label;
            menu.appendChild(groupLabelItem);
            for (const item of option.children) {
                addOption(item, true);
            }
        } else {
            addOption(option);
        }
    }
    $slot.append(menu);
    $select.change(function() {
        const value = $select.val();
        const option = Array.from(this.options).find(option => option.value === value);
        if (option) {
            Array.from(menu.childNodes).forEach(item => {
                if (item.innerText === option.text){
                    item.classList.add('select-box__menu-item--selected');
                } else {
                    item.classList.remove('select-box__menu-item--selected');
                }
            });
            activatorText.innerText = option.text;
        }
    })
});

$('.select-box').click(function (e) {
    e.preventDefault();
    let $this = $(this);
    if (!$this.hasClass('select-box--disabled')) {
        $this.toggleClass('select-box--active');
    }
});

document.addEventListener('click', function (e) {
    for (const elem of Array.from(document.querySelectorAll('.select-box--active'))) {
        if (!elem.contains(e.target)) {
            elem.classList.remove('select-box--active');
        }
    }
}, true);
